module.exports = __webpack_public_path__ + "img/icon-r-walkthrough.8d2e4863.svg";